var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',_vm._b({attrs:{"options":_vm.shops,"custom-label":function (ref) {
	var id = ref.id;
	var name = ref.name;

	return ("" + name);
},"track-by":"id","placeholder":_vm.$attrs.placeholder || 'Select a Shop',"show-labels":true,"allow-empty":true,"multiple":_vm.multiple},on:{"input":_vm.onSelected,"close":function($event){return _vm.$emit('blur')}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'Multiselect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }